import BackgroundLayer from "@/components/BackgroundLayer";
import RadioGroup from "@/components/RadioGroup";
import { ListenButton } from "@/components/AudioControls";

const EVENT_OPTIONS = [
  { value: "A", label: "Hold. My long-term thesis hasn't changed." },
  { value: "B", label: "Reduce my allocation in risky assets by 10–15%. Get more defensive." },
  { value: "C", label: "Move a meaningful portion to cash or safety assets. Protect what I have." },
  { value: "D", label: "Actually increase my allocation in risky assets. Prices are lower now." },
  { value: "E", label: "My advisor would have a recommendation for this." },
];

export default function MarketEvent1({ sessionData, updateSession, onNext, onBack, stageIndex }) {
  return (
    <div className="page-wrapper" data-testid="market-event1-page">
      <BackgroundLayer image="/images/page3_bg_event1.jpg" />
      <div className="content-layer" style={{ minHeight: "100vh", minHeight: "100dvh" }}>
        <div className="page-content" style={{ paddingTop: 60, paddingBottom: 80 }}>
          <div className="section-label animate-in" style={{ marginBottom: 12 }}>02: The Market Moves</div>
          <div className="animate-in animate-in-d1" style={{ marginBottom: 20 }}>
            <ListenButton stageIndex={stageIndex} />
          </div>

          <div className="section-text-block">
            <h2 className="section-heading animate-in animate-in-d1" style={{ marginBottom: 20 }}>
              Event 1 — September 15, 2008:
            </h2>
            <p className="standout-line animate-in animate-in-d2" style={{ marginBottom: 4 }}>
              Lehman Brothers files for bankruptcy.
            </p>
            <p className="body-text animate-in animate-in-d2">
              The largest bankruptcy in U.S. history.
            </p>
            <p className="body-text animate-in animate-in-d3">
              The S&P 500 falls 4.7% in a single day.
            </p>
            <p className="body-text animate-in animate-in-d3">
              Your portfolio is now down more than 3.5%.
            </p>
            <p className="body-text animate-in animate-in-d4">
              The overall conditions continue looming even more each day.
            </p>

            <p className="standout-line animate-in animate-in-d5" style={{ marginTop: 28, marginBottom: 12 }}>
              What do you do?
            </p>
          </div>

          <div className="animate-in animate-in-d6">
            <RadioGroup
              name="e1"
              options={EVENT_OPTIONS}
              selected={sessionData.e1}
              onSelect={(v) => updateSession("e1", v)}
            />
          </div>

          <div className="nav-buttons animate-in animate-in-d7">
            <button className="nav-back" onClick={onBack} data-testid="back-btn">Back</button>
            <button
              className="cta-pill"
              onClick={onNext}
              disabled={!sessionData.e1}
              data-testid="next-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
